import React from 'react'
import { IconButton } from '@mui/material'
import { SxProps } from '@mui/material'
import MenuClose from 'assets/icons/MenuClose.png'

function CrossDialogBtn(props: { dialogClose: () => void; sx?: SxProps }) {
  const { dialogClose, sx } = props
  return (
    <IconButton
      onClick={dialogClose}
      size='small'
      data-cy='closeDialogBtn'
      sx={{
        mr: '-10px',
        mt: '-10px',
        width: '40px',
        height: '40px',
        ...sx
      }}
    >
      <img
        style={{
          width: '20px',
          height: 'auto'
        }}
        src={MenuClose}
      />
    </IconButton>
  )
}

export default CrossDialogBtn
